import * as React from 'react'
// libs
import remarkGfm from 'remark-gfm'
import ReactMarkdown, { Components } from 'react-markdown'

const COMPONENTS: Components = {
  a: ({ node: _node, ...props }) => <a {...props} target='_blank' rel='noopener noreferrer' />
}

const Markdown: React.FC<{ children: string }> = ({ children }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTS}>
    {children}
  </ReactMarkdown>
)

export default Markdown
